import request from '@/utils/server'
// 新增
export function updateTrainCover(data) {
    return request({
      url: '/homeFunc/updateTrainCover',
      method: 'POST',
      data: data
    })
  }
  //   查询
export function findTrainCover(query) {
    return request({
      url: '/homeFunc/findTrainCover',
      method: 'get',
      params: query
    })
  }